import styled from "styled-components";
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const HeaderNavbarRightContainerDefaultBox = styled.div`
  display: flex;
  align-items: center;

  margin: 0 0 0 auto;
  ${CssRule.For.RTL.build()} & {
    margin: 0 auto 0 0;
  }

  min-height: 4.5rem; // Preserve height for the content to avoid CLS issues.
  
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    min-height: 4rem; // Preserve height for the content to avoid CLS issues.
  }
`;
